<!-- CUSTOM CURSOR -->
<!-- OUTLINE -->
<div #cursorOutline class="cursor-outline">
  <div class="cursor-outline-inner"></div>
</div>

<!-- DOT -->
<div #cursorDot class="cursor-dot">
  <div class="cursor-dot-inner"></div>
</div>


<!-- BACKGROUND BLURS -->
<div class="fixed inset-0 overflow-hidden pointer-events-none -z-10">
  <div class="absolute -top-[10%] -left-[5%] size-[500px] rounded-full bg-primary/5 blur-[120px]"></div>
  <div class="absolute bottom-[10%] -right-[5%] size-[600px] rounded-full bg-accent/5 blur-[150px]"></div>
</div>


<div class="min-h-screen flex flex-col bg-transparent relative z-10">
    <app-navbar />

    <router-outlet></router-outlet>

    <app-footer />
</div>